const AnswerPreProcessForCodeTagHelper = (sanitizedHTML: string): string => {
    return sanitizedHTML.replace(/```.*?```/gs, match => {
        return `${match}\n`;
    });
};

export default AnswerPreProcessForCodeTagHelper;
